// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"0cbf625b","456":"8f486a85"}[chunkId] + ".chunk.js";
};